var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.testType(_vm.inputelement),{tag:"component",attrs:{"inputelement":_vm.inputelement},on:{"deleteCritere":function($event){return _vm.deleteFormCritere($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }